<template>
  <div class="info">
    <div class="g-box">
      <div class="info-cap">{{ info.title }}</div>
      <EditCont :content="info.content" class="info-bd" />
    </div>
  </div>
</template>

<script>
import EditCont from "../../components/EditCont";
import pageMain_mx from "../../mixins/pageMain_mx";

export default {
  data() {
    return {};
  },
  mixins: [pageMain_mx],
  components: { EditCont },
  mounted() {},
  methods: {
    init() {
      this.params = this.$route.params;
      this.getInfo();
    }
  }
};
</script>
<style lang="less">
.info {
  padding-top: 98px;
}
.info-cap {
  color: #282828;
  font-size: 24px;
  text-align: center;
  font-weight: bold;
}
.info-bd {
  font-size: 16px;
  color: #979797;
  margin-top: 52px;
  line-height: 30px;
  padding-bottom: 100px;
}
</style>
